/*
 * Русский перевод общих компонентов Backstage: вход, таблицы, страница ошибки, поддержка.
 */
import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/core-plugin-api/alpha';
import { coreComponentsTranslationRef } from '@backstage/core-components';

const plurals: Record<string, string> = {
  'alertDisplay.message_few': '({{ count }} новых сообщения)',
  'alertDisplay.message_many': '({{ count }} новых сообщений)',
};

const coreRu = createTranslationMessages({
  ref: coreComponentsTranslationRef,
  full: false,
  messages: {
    ...plurals,
    'signIn.title': 'Вход',
    'signIn.loginFailed': 'Не удалось войти',
    'signIn.customProvider.title': 'Свой пользователь',
    'signIn.customProvider.subtitle':
      'Введите свой ID пользователя и учётные данные.\n Выбор не сохраняется.',
    'signIn.customProvider.userId': 'ID пользователя',
    'signIn.customProvider.tokenInvalid':
      'Токен не является корректным OpenID Connect JWT',
    'signIn.customProvider.continue': 'Продолжить',
    'signIn.customProvider.idToken': 'ID-токен (необязательно)',
    'signIn.guestProvider.title': 'Гость',
    'signIn.guestProvider.subtitle':
      'Войти гостем.\n Без подтверждённой личности часть возможностей недоступна.',
    'signIn.guestProvider.enter': 'Войти',
    skipToContent: 'К содержимому',
    'copyTextButton.tooltipText': 'Скопировано в буфер обмена',
    'simpleStepper.reset': 'Сбросить',
    'simpleStepper.finish': 'Готово',
    'simpleStepper.next': 'Далее',
    'simpleStepper.skip': 'Пропустить',
    'simpleStepper.back': 'Назад',
    'errorPage.subtitle': 'ОШИБКА {{status}}: {{statusMessage}}',
    'errorPage.title': 'Что-то пошло не так',
    'errorPage.goBack': 'Назад',
    'errorPage.showMoreDetails': 'Подробнее',
    'errorPage.showLessDetails': 'Скрыть подробности',
    'emptyState.missingAnnotation.title': 'Нет аннотации',
    'emptyState.missingAnnotation.actionTitle':
      'Добавьте аннотацию в YAML компонента, как в примере ниже:',
    'emptyState.missingAnnotation.readMore': 'Подробнее',
    'supportConfig.default.title': 'Поддержка не настроена',
    'supportConfig.default.linkTitle':
      'Добавьте ключ конфигурации `app.support`',
    'errorBoundary.title': 'За помощью обращайтесь в {{slackChannel}}.',
    'oauthRequestDialog.title': 'Требуется вход',
    'oauthRequestDialog.authRedirectTitle':
      'Будет выполнен переход на страницу входа OAuth.',
    'oauthRequestDialog.login': 'Войти',
    'oauthRequestDialog.rejectAll': 'Отклонить все',
    'oauthRequestDialog.message':
      'Войдите, чтобы разрешить {{appTitle}} доступ к API и учётным данным {{provider}}.',
    'supportButton.title': 'Поддержка',
    'supportButton.close': 'Закрыть',
    'table.filter.title': 'Фильтры',
    'table.filter.clearAll': 'Сбросить все',
    'table.filter.placeholder': 'Все результаты',
    'table.body.emptyDataSourceMessage': 'Записей нет',
    'table.pagination.firstTooltip': 'Первая страница',
    'table.pagination.labelDisplayedRows': '{from}–{to} из {count}',
    'table.pagination.labelRowsSelect': 'строк',
    'table.pagination.lastTooltip': 'Последняя страница',
    'table.pagination.nextTooltip': 'Следующая страница',
    'table.pagination.previousTooltip': 'Предыдущая страница',
    'table.toolbar.search': 'Фильтр',
    'table.header.actions': 'Действия',
    'alertDisplay.message_one': '({{ count }} новое сообщение)',
    'alertDisplay.message_other': '({{ count }} новых сообщений)',
    'autoLogout.stillTherePrompt.title': 'Выход из-за неактивности',
    'autoLogout.stillTherePrompt.buttonText': 'Я здесь, не выходить',
    'dependencyGraph.fullscreenTooltip': 'На весь экран',
    'proxiedSignInPage.title':
      'Похоже, вы не вошли. Попробуйте перезагрузить страницу.',
    'logViewer.downloadBtn.tooltip': 'Скачать логи',
    'logViewer.searchField.placeholder': 'Поиск',
  },
});

export const coreTranslations = [
  createTranslationResource({
    ref: coreComponentsTranslationRef,
    translations: { ru: () => Promise.resolve({ default: coreRu }) },
  }),
];
